import * as React from "react";

function FbReview(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={212.99}
      height={58.01}
      {...props}
    >
      <defs>
        <radialGradient
          id="prefix__c"
          cx={0.715}
          cy={1.111}
          r={4.834}
          gradientTransform="matrix(.233 0 0 -1 .549 25.271)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a8a8a8" />
          <stop offset={0.093} stopColor="#898989" />
          <stop offset={0.235} stopColor="#5f5f5f" />
          <stop offset={0.38} stopColor="#3d3d3d" />
          <stop offset={0.528} stopColor="#222" />
          <stop offset={0.678} stopColor="#0f0f0f" />
          <stop offset={0.831} stopColor="#040404" />
          <stop offset={0.995} />
        </radialGradient>
        <clipPath id="prefix__a">
          <path fill="none" d="M0 0h212.99v58.01H0z" />
        </clipPath>
        <style>
          {
            ".prefix__b{clip-path:url(#prefix__a)}.prefix__e{fill:#ffc200}.prefix__g{fill:#fff}"
          }
        </style>
      </defs>
      <path fill="#000054" d="M0 0h212.99v58.01H0z" />
      <path
        d="M-4771.236-1049.607s-192.492 55.317-249.386 58.01h249.386z"
        transform="translate(4984.226 1058.082)"
        style={{
          isolation: "isolate",
          mixBlendMode: "color-dodge",
        }}
        opacity={0.46}
        fill="url(#prefix__c)"
      />
      <g className="prefix__b">
        <path
          className="prefix__e"
          d="M132.314 21.12a.692.692 0 00-.657-.526l-4.27-.394-1.708-3.942a.791.791 0 00-1.051-.394.591.591 0 00-.394.394l-1.709 3.942-4.27.394a.8.8 0 00-.722.854.81.81 0 00.263.526l3.219 2.825-.986 4.2a.812.812 0 00.592.92.925.925 0 00.59-.066l3.679-2.234 3.679 2.234a.745.745 0 001.051-.263.64.64 0 00.066-.591l-.985-4.2 3.219-2.825a.772.772 0 00.395-.854zM149.132 21.12a.691.691 0 00-.657-.526l-4.271-.394-1.708-3.942a.791.791 0 00-1.051-.394.593.593 0 00-.395.394l-1.708 3.942-4.27.394a.8.8 0 00-.723.854.807.807 0 00.264.526l3.219 2.825-.986 4.2a.813.813 0 00.591.92.928.928 0 00.592-.066l3.679-2.234 3.679 2.234a.746.746 0 001.051-.263.636.636 0 00.065-.591l-.985-4.2 3.219-2.825c.394-.263.526-.591.394-.854zM166.017 21.12a.692.692 0 00-.657-.526l-4.271-.394-1.708-3.942a.791.791 0 00-1.051-.394.591.591 0 00-.394.394l-1.708 3.942-4.27.394a.8.8 0 00-.723.854.81.81 0 00.263.526l3.218 2.825-.985 4.2a.811.811 0 00.592.92.928.928 0 00.591-.066l3.679-2.234 3.679 2.234a.745.745 0 001.051-.263.638.638 0 00.066-.591l-.985-4.2 3.219-2.825c.395-.263.525-.591.395-.854zM182.9 21.12a.691.691 0 00-.656-.526l-4.271-.394-1.708-3.942a.792.792 0 00-1.052-.394.591.591 0 00-.394.394l-1.708 3.942-4.271.394a.8.8 0 00-.722.854.81.81 0 00.263.526l3.219 2.825-.984 4.2a.81.81 0 00.59.92.927.927 0 00.591-.066l3.679-2.234 3.68 2.234a.745.745 0 001.051-.263.641.641 0 00.065-.591l-.985-4.2 3.219-2.825a.771.771 0 00.395-.854zM199.718 21.12a.691.691 0 00-.657-.526l-4.27-.394-1.708-3.942a.793.793 0 00-1.052-.394.592.592 0 00-.394.394l-1.708 3.942-4.27.394a.8.8 0 00-.723.854.807.807 0 00.264.526l3.219 2.825-.986 4.2a.813.813 0 00.591.92.928.928 0 00.592-.066l3.679-2.234 3.679 2.234a.746.746 0 001.051-.263.638.638 0 00.065-.591l-.985-4.2 3.219-2.825c.459-.263.526-.591.394-.854z"
        />
        <text
          transform="translate(158.655 43.996)"
          style={{
            isolation: "isolate",
          }}
          fontSize={9}
          fontFamily="OpenSans,Open Sans"
          fill="#fff"
        >
          <tspan x={-33.855} y={0}>
            {"97 reviews | 5/5"}
          </tspan>
        </text>
      </g>
      <g className="prefix__b">
        <path
          className="prefix__g"
          d="M18.133 23.257c-.985 0-1.314.46-1.314 1.445v1.642h2.694l-.263 2.628h-2.432v8.081H13.6v-8.081h-2.168v-2.628H13.6v-1.577c0-2.693 1.051-4.073 4.073-4.073a15.35 15.35 0 011.905.131v2.5M19.709 31.404c0-3.022 1.445-5.256 4.4-5.256a3.209 3.209 0 013.087 1.839v-1.642h3.088v10.709h-3.088v-1.643a3.114 3.114 0 01-3.087 1.84c-2.957 0-4.4-2.234-4.4-5.256m3.285.131c0 1.577.591 2.628 2.1 2.628 1.314 0 2.037-.985 2.037-2.5v-1.051c0-1.511-.657-2.5-2.037-2.5-1.511 0-2.1 1.051-2.1 2.628zM37.057 26.148a5.8 5.8 0 013.087.723l-.723 2.3a5.01 5.01 0 00-2.167-.526c-1.774 0-2.5.985-2.5 2.759v.657c0 1.708.789 2.759 2.5 2.759a5.011 5.011 0 002.167-.526l.723 2.3a5.8 5.8 0 01-3.087.723c-3.811 0-5.519-2.037-5.519-5.321v-.526c0-3.285 1.708-5.321 5.519-5.321M40.601 32.126v-.92c0-3.022 1.708-5.059 5.255-5.059 3.351 0 4.8 2.037 4.8 4.993v1.708h-6.833c.066 1.445.723 2.1 2.5 2.1a9.045 9.045 0 003.417-.657l.591 2.234a10.307 10.307 0 01-4.14.788c-4.007 0-5.583-2.037-5.583-5.19m3.285-1.38h3.942v-.263c0-1.183-.46-2.1-1.905-2.1-1.512 0-2.037.92-2.037 2.365M62.741 32.061c0 3.022-1.445 5.256-4.4 5.256a3.31 3.31 0 01-3.219-1.84v1.642h-3.088v-16.1l3.219-.263v7.161a3.269 3.269 0 013.021-1.708c2.956 0 4.4 2.234 4.4 5.256m-3.219-.131c0-1.511-.592-2.628-2.168-2.628-1.314 0-2.037.92-2.037 2.5v1.117c0 1.511.723 2.5 2.037 2.5 1.576 0 2.168-1.117 2.168-2.628zM63.792 31.995v-.526c0-3.088 1.773-5.321 5.321-5.321 3.614 0 5.321 2.234 5.321 5.321v.526c0 3.088-1.774 5.321-5.321 5.321s-5.321-2.234-5.321-5.321m7.423-.788c0-1.445-.591-2.562-2.1-2.562s-2.1 1.117-2.1 2.562v.985c0 1.445.592 2.562 2.1 2.562s2.1-1.117 2.1-2.562zM75.552 31.995v-.526c0-3.088 1.773-5.321 5.321-5.321 3.613 0 5.321 2.234 5.321 5.321v.526c0 3.088-1.773 5.321-5.321 5.321s-5.321-2.234-5.321-5.321m7.424-.788c0-1.445-.591-2.562-2.1-2.562s-2.1 1.117-2.1 2.562v.985c0 1.445.591 2.562 2.1 2.562s2.1-1.117 2.1-2.562zM90.728 31.469l3.154-5.124h3.481l-3.35 5.322 3.482 5.387h-3.482l-3.285-5.256v5.256h-3.285v-16.1l3.285-.263"
        />
      </g>
    </svg>
  );
}

export default FbReview;
